import { useContext } from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { AddFileNavigationPositionEnum } from '../../../../domain/enum/AddFileNavigationPosition';
import { AddVideoModalContext } from '../context/AddVideoModalContext';

export function IndexScreen() {
    const {
        navigationPosition, handleAddFileButton, isInvalidVideoInput, handleVideoLinkChange, errorMessage, videoObject, returnVideoUrlSRC, setNavigationPosition
    } = useContext(AddVideoModalContext);
    return <>
        <Row>
            <Col>
                <p>
                    Como você quer enviar seu vídeo?
                </p>
            </Col>
        </Row>
        <Row className="py-2">
            <Col>
                <Button className='w-100 add-content px-3' onClick={() => setNavigationPosition(AddFileNavigationPositionEnum.sendFile)}>
                    <Row className="mb-2">
                        <Col md="auto" className="my-auto pr-0">
                            <i className="bi bi-upload" />
                        </Col>
                        <Col className="my-auto">
                            <h3>
                                Enviar arquivo do meu computador
                            </h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>
                                Escolha um arquivo do seu computador.
                            </p>
                        </Col>
                    </Row>
                </Button>
            </Col>
        </Row>
        <Row className="py-2">
            <Col>
                <Button className='w-100 add-content px-3' onClick={() => setNavigationPosition(AddFileNavigationPositionEnum.sendLink)}>
                    <Row className="mb-2">
                        <Col md="auto" className="my-auto pr-0">
                            <i className="bi bi-link-45deg" />
                        </Col>
                        <Col className="my-auto">
                            <h3>
                                Enviar um vídeo da internet
                            </h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>
                                Você pode adicionar vídeos das plataformas YouTube ou Vimeo.
                            </p>
                        </Col>
                    </Row>
                </Button>
            </Col>
        </Row>
    </>;
}
